import { SUBMIT_QUIZ } from '~/graphql/mutations/quiz'

const actionTypes = {
  SUBMIT_QUIZ: 'SUBMIT_QUIZ',
}

const mutationTypes = {
  SET_SUBMITTING: 'SET_SUBMITTING',
  SET_SUBMITTING_ERROR: 'SET_SUBMITTING_ERROR',
}

export const state = () => ({
  error: false,
  submitting: false,
})

export const mutations = {
  [mutationTypes.SET_SUBMITTING](state, submitting) {
    state.submitting = submitting
  },
  [mutationTypes.SET_SUBMITTING_ERROR](state, error) {
    state.submitting = false
    state.error = error
  },
}

export const actions = {
  async [actionTypes.SUBMIT_QUIZ]({ commit }, params) {
    commit(mutationTypes.SET_SUBMITTING, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: SUBMIT_QUIZ,
        variables: {
          ...params,
        },
      })
      commit(mutationTypes.SET_SUBMITTING, true)
      return { data: data.academySubmitQuiz, success: true }
    } catch (error) {
      commit(mutationTypes.SET_FETCHING_ERROR, error)
      return { error, success: false }
    }
  },
}

export const getters = {
  error: (state) => state.error,
  submitting: (state) => state.submitting,
}
